import React from 'react'
import ReactDOM from 'react-dom/client'
import Portfolio from './Portfolio'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Portfolio />
  </React.StrictMode>,
)
